import { Toaster as SonnerToaster } from "sonner";

/**
 * Toaster — sonner wrapper themed via brand tokens (--popover, --border, etc.).
 *
 * Mount once at the app root; call sonner's toast() / toast.success() etc.
 * from anywhere via `import { toast } from "sonner"`.
 */
const Toaster = ({ ...props }) => (
  <SonnerToaster
    theme="dark"
    position="bottom-right"
    closeButton
    richColors
    toastOptions={{
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton:
          "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton:
          "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
      },
    }}
    {...props}
  />
);

export { Toaster };
